// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"_1a6ca59a5fa16cd4fe912db20ee7cd9f-less"};